// extracted by mini-css-extract-plugin
export default {"Container":"Card_Container__zVGo4","ClickableContainer":"Card_ClickableContainer__p+5PO","ClickableContainer--active":"Card_ClickableContainer--active__+hkXs"};